import { Injectable } from '@angular/core';
import { LocalStoragePersister } from '../../infrastructure/local-storage-persister';

const PERSISTENCE_KEY = 'last_page';

@Injectable({ providedIn: 'root' })
export class LastPageVisitedService {
    constructor(private readonly persister: LocalStoragePersister<string>) {}

    set(url: string): void {
        this.persister.set(PERSISTENCE_KEY, url);
    }

    get(): string | null {
        return this.persister.get(PERSISTENCE_KEY);
    }
}
